import { useQuery } from '@tanstack/react-query';
import { useApiV2 } from '@/shared/api';
import { plantQueryOptions } from './plant.query-options';

/**
 * 단건 발전소 query — plan 페이지가 진입 발전소 1건을 목록과 무관하게 직접 조회(딥링크 안전).
 * 빈 `plantId` 면 비활성(`enabled:false`). 발전소는 v2 (`useApiV2`).
 */
export function usePlantQuery(plantId: string) {
  const api = useApiV2();
  return useQuery(plantQueryOptions(api, plantId));
}
